import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';

class BudgetDistributionAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'BudgetDistributions';
}

export default new BudgetDistributionAPI();
